const Stepper = ({ currentStep }: { currentStep: number }) => {
  const steps = ['Choose Creation Method', 'Details', 'Template', 'Preview'];

  return (
    <div className='mx-auto mb-8 mt-4 w-full max-w-5xl'>
      <div className='flex items-center justify-between'>
        {steps.map((step, index) => {
          const stepNumber = index + 1;

          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <div key={step} className='flex items-center'>
              {/* Step */}
              <div
                className={`flex flex-col items-center gap-1 ${
                  !isActive && !isCompleted ? 'opacity-50' : ''
                }`}
              >
                <div
                  className={`flex items-center justify-center rounded-full font-bold
                      ${
                        isActive
                          ? 'h-8 w-8 bg-brand text-sm text-white shadow-md'
                          : isCompleted
                            ? 'h-7 w-7 bg-delta text-xs text-brand'
                            : 'h-7 w-7 bg-gray-200 text-xs text-gray-500'
                      }`}
                >
                  {stepNumber}
                </div>

                <span
                  className={`text-center text-[10px] font-bold uppercase tracking-widest
                      ${
                        isActive || isCompleted ? 'text-brand' : 'text-gray-400'
                      }`}
                >
                  {step}
                </span>
              </div>

              {/* Line */}
              {index !== steps.length - 1 && (
                <div
                  className={`mx-3 h-[2px] w-40 rounded-full
                      ${stepNumber < currentStep ? 'bg-brand' : 'bg-gray-200'}`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
